import { ElementType, JSX, PropsWithChildren } from 'react'
import { cn } from '../utils'

type HeadingTag = keyof Pick<
  JSX.IntrinsicElements,
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>

type SemanticTag = keyof JSX.IntrinsicElements & keyof HTMLElementTagNameMap

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  tag: HeadingTag
  variant?: SemanticTag
}

export default function Heading({
  children,
  tag,
  variant,
  className,
  ...props
}: PropsWithChildren<HeadingProps>) {
  const Tag = (variant ?? tag) as ElementType
  const base = 'elm-headline'
  const spacing = determineSpacing(tag)

  return (
    <Tag className={cn([base, spacing, className])} {...props}>
      {children}
    </Tag>
  )
}

function determineSpacing(tag: HeadingTag) {
  if (tag === 'h1') return 'my-2.5'
  else if (tag === 'h2') return 'mt-1.5 mb-1'
  else return ''
}
